import SvgQuestionMark from "@/app/components/lib/SvgQuestionMark";
import Badge from "@/app/components/lib/badge";
import AppToast from "@/app/components/lib/toast/AppToast";
import Tooltip from "@/app/components/lib/tooltip";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useState } from "react";
import SvgMinus from "./btn-expanding-icons/SvgMinus";
import SvgPlus from "./btn-expanding-icons/SvgPlus";
import SvgRecycleBin from "./btn-expanding-icons/SvgRecycleBin";
import SvgSmallShowDetails from "./btn-expanding-icons/SvgSmallShowDetails";
import SvgCheck from "./btn-expanding-icons/SvgCheck";
import { useTranslation } from "@/hooks/localization/useTranslations";
import ExpandingQuantityInput from "./ExpandingQuantityInput";
import { IEventCustomData } from "@/api/AppApi/services/home/IEvent";
import ReminderButton from "../ReminderButton";
import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";
interface Props {
  quantity: number;
  increaseQty: (e: React.MouseEvent, value?: number) => void;
  decreaseQty: (value?: number) => void;
  viewDetails: boolean;
  outOfStock: boolean;
  maxQuantity: number;
  minQuantity: number;
  enable_sells: boolean;
  viewDetailsClick: () => void;
  isConfigurableProduct: boolean;
  addToCartTxt?: string;
  handleChangeQty: (value: number) => void;
  preview_type: string;
  custom_data?: IEventCustomData;
  shouldReminder?: boolean;
  productProps?: IProduct;
}
const VBtnExpandingAddToCard: React.FC<Props> = ({
  quantity,
  increaseQty,
  decreaseQty,
  viewDetails,
  outOfStock,
  maxQuantity,
  minQuantity,
  enable_sells,
  viewDetailsClick,
  isConfigurableProduct,
  handleChangeQty,
  preview_type,
  custom_data,
  shouldReminder,
  productProps,
}) => {
  const isMobile = useIsMobile();
  const t = useTranslation();
  const { enable_registration } = custom_data ?? {};

  const disabled =
    outOfStock ||
    !(enable_sells || viewDetails) ||
    (preview_type === "event" && !enable_registration);

  const valueToDecrease = quantity === minQuantity ? minQuantity : 1;

  const [openToast, setOpenToast] = useState(false);

  console.log({ shouldReminder });
  if (shouldReminder && outOfStock) {
    return (
      <ReminderButton
        small
        product={{
          name: productProps?.name!,
          description: productProps?.description!,
          image: productProps?.image_url!,
          rate: productProps?.rate,
          id: productProps?.id!,
        }}
      />
    );
  }
  return (
    <>
      {quantity === 0 ? (
        <button
          className={`btn-expanded-v-add-to-card`}
          onClick={(e) =>
            viewDetails ? viewDetailsClick() : increaseQty(e, minQuantity)
          }
          disabled={disabled}
        >
          {viewDetails && !isConfigurableProduct ? (
            <SvgSmallShowDetails />
          ) : (
            <div style={{ marginTop: -2 }}>
              <SvgPlus disabled={outOfStock || !enable_sells} />
            </div>
          )}
        </button>
      ) : isConfigurableProduct || viewDetails || preview_type === "event" ? (
        <button className={`btn-expanded-check`} onClick={viewDetailsClick}>
          <SvgCheck />
        </button>
      ) : (
        <div className="btn-expanded-v-add-to-card-counter">
          <div onClick={(e) => quantity < maxQuantity && increaseQty(e)}>
            <SvgPlus disabled={quantity === maxQuantity} />
          </div>
          {minQuantity > 1 && minQuantity === quantity ? (
            <div
              style={{ display: "flex", flexDirection: "column" }}
              onClick={() => isMobile && setOpenToast(true)}
            >
              <Badge
                badgeComponent={
                  <Tooltip
                    text={`${t.min_quantity_in_cart} ${minQuantity}`}
                    skip={isMobile}
                  >
                    <SvgQuestionMark />
                  </Tooltip>
                }
              >
                <ExpandingQuantityInput
                  quantity={quantity}
                  setQuantity={handleChangeQty}
                />
              </Badge>
            </div>
          ) : (
            <ExpandingQuantityInput
              quantity={quantity}
              setQuantity={handleChangeQty}
            />
          )}
          {quantity > minQuantity && (
            <div onClick={() => decreaseQty(valueToDecrease)}>
              <SvgMinus />
            </div>
          )}
          <div onClick={() => handleChangeQty(0)}>
            <SvgRecycleBin />
          </div>
        </div>
      )}
      <AppToast
        message={`${t.min_quantity_in_cart} ${minQuantity}`}
        setShow={setOpenToast}
        show={openToast}
        paddingBottom={80}
        width="300px"
        cancelIcon={false}
        delay={3000}
      />
    </>
  );
};

export default VBtnExpandingAddToCard;
